import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("View ")
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(".")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", null, [
    _hoisted_1,
    _createElementVNode("a", {
      class: "nes-text is-primary",
      href: _ctx.uri,
      target: "_blank"
    }, "confirmed transaction", 8, _hoisted_2),
    _hoisted_3
  ]))
}